import { motion } from "framer-motion";
import photo1 from "@/assets/gallery/photo-1.jpg";
import photo2 from "@/assets/gallery/photo-2.jpg";
import photo3 from "@/assets/gallery/photo-3.jpg";
import photo4 from "@/assets/gallery/photo-4.jpeg";
import photo5 from "@/assets/gallery/photo-5.jpg";
import photo6 from "@/assets/gallery/photo-6.jpeg";

const photos = [
  {
    src: photo1,
    alt: "Couple Photo 1",
    rotate: "rotate-2",
  },
  {
    src: photo2,
    alt: "Couple Photo 2",
    rotate: "-rotate-1",
  },
  {
    src: photo3,
    alt: "Couple Photo 3",
    rotate: "rotate-3",
  },
  {
    src: photo4,
    alt: "Couple Photo 4",
    rotate: "-rotate-2",
  },
  {
    src: photo5,
    alt: "Couple Photo 5",
    rotate: "rotate-1",
  },
  {
    src: photo6,
    alt: "Couple Photo 6",
    rotate: "-rotate-3",
  },
];

interface GallerySectionProps {
  assetMap?: Record<string, string>;
}

export function GallerySection({ assetMap }: GallerySectionProps) {
  return (
    <section
      id="gallery"
      className="relative w-full py-24 px-6 bg-[#F7F5F2] overflow-hidden"
    >
      <div className="max-w-4xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <motion.h2
            className="font-serif text-3xl md:text-4xl text-stone-800 mb-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            Our Moments
          </motion.h2>
          <motion.p
            className="font-handwriting text-2xl text-stone-600"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            Memories we cherish
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {photos.map((photo, index) => (
            <motion.div
              key={index}
              className={`relative p-3 bg-white shadow-md ${photo.rotate} hover:rotate-0 hover:z-20 transition-all duration-300 ease-in-out cursor-pointer`}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ delay: index * 0.1 }}
            >
              <div className="w-full aspect-[3/4] overflow-hidden bg-stone-200">
                <img
                  src={assetMap?.[photo.src] || photo.src}
                  alt={photo.alt}
                  className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500"
                />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
